import { Component, OnInit, Inject, Injector } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialDialog } from 'app/modules/shared/components/dialog/dialog.component';
import { DialogData } from 'app/core/interfaces/dialog';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { Agreements, HealthcarePlans, PaymentSettings } from 'app/core/interfaces/payment-settings';
import { OrganizationSettingsService } from 'app/core/http/services/organization-settings';
import { EncounterService } from 'app/core/http/services/encounter.service';

@Component({
  selector: 'change-schedule-method-details',
  templateUrl: './change-schedule-method.component.html',
  styleUrls: ['./change-schedule-method.component.scss'],
})
export class ChangeScheduleMethodComponent extends BaseComponent implements OnInit {
  public encounter: any;
  public scheduling_method: string | undefined = '';
  public healthPlansOrganization: HealthcarePlans[] = [];
  public organizationSettings!: PaymentSettings;
  public healPlanAgreement: Agreements[] = [];

  constructor(
    public dialogRef: MatDialogRef<MaterialDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private injector: Injector,
    private organizationSettingsService: OrganizationSettingsService,
    private encounterService: EncounterService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.encounter = this.data.param.encounter;
    this.scheduling_method = this.encounter.scheduling_method;

    this.getOrganizationSettings();
  }

  getOrganizationSettings() {
    const organizationId = this.encounter.serviceProvider.code;

    this.organizationSettingsService.findByOrganization(organizationId).subscribe({
      next: (settings: PaymentSettings[]) => {
        this.organizationSettings = settings[0];
        this.healthPlansOrganization = this.organizationSettings.healthcare_plans!!;
        this.healthPlansOrganization = this.healthPlansOrganization.filter((healthcarePlan) => healthcarePlan.accepted == true);
      },
      error: (err) => {
        console.error('Falha ao buscar organizações');
      },
    });
  }

  setHealthPlanAgreements(healthPlanName?: string) {
    if (healthPlanName == undefined) this.healPlanAgreement = [];
    const healthcarePLan = this.healthPlansOrganization.find((healthcareplan: HealthcarePlans) => healthcareplan.name == healthPlanName);
    this.healPlanAgreement = healthcarePLan?.agreements!!;
  }

  isFormValid(): boolean {
    const healthPlan = this.encounter?.health_plan;

    if (this.encounter?.scheduling_method === 'CONVENIO') {
      return healthPlan?.health_plan_name?.trim() && healthPlan?.agreement?.trim() && healthPlan?.card_number?.trim();
    }

    if (this.encounter?.scheduling_method === 'PARTICULAR') {
      return true;
    }

    return false;
  }

  save() {
    const encounterFormValues = {
      ...this.encounter,
      active: true,
    };

    this.encounterService.update(this.encounter.encounter_id, encounterFormValues).subscribe({
      next: (encounter: any) => {
        this.showSuccessMessage = true;
        this.showErrorMessage = false;
      },
      error: (err) => {
        this.showSuccessMessage = false;
        this.showErrorMessage = true;
        console.log(err);
      },
    });
  }
}
